// removed by extract-text-webpack-plugin
module.exports = {"name":"_2pwew","fy":"_25MIG","status":"cDtkx","lastUpdated":"vW29W","view":"w0rj8","header":"_33MPY","description":"_2_6DM"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TemplateUpload/columns.scss
// module id = 331
// module chunks = 0